import { useContext } from "react"
import { Navigate } from "react-router-dom"
import { siteDetailsContext } from "../context/SiteDetailsContext"
import { LoginContext } from "../context/LoginContext"

const SiteDetailsRoute = ({ children }) => {
    const { siteDetails } = useContext(siteDetailsContext)
    const user = useContext(LoginContext)
    return (
        <>
            {
                (!siteDetails.length && !user) ? <Navigate to="/account/add-site" /> : children
            }
        </>
    )
}

export default SiteDetailsRoute;